// extracted by mini-css-extract-plugin
var _1 = "hJNftRhOax2mj9Kipn6Z";
var _2 = "V2UJ96NZrBBHdKn0p2N8";
var _3 = "vC5Lzud4kD7bVZjcMyMQ";
var _4 = "hE0Uo9eCRaOcWmec_P4j";
export { _1 as "marginTop", _2 as "musicIcons", _3 as "musicPlayer", _4 as "startMusicButton" }
